var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "716.684px",
    height: "715.904px",
    viewBox: "0 0 716.684 715.904",
    enableBackground: "new 0 0 716.684 715.904",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1.175,358.104c8.055,8.055,350.062,350.061,358.115,358.111c8.055-8.053,350.068-350.06,358.123-358.111 C709.359,350.05,367.345,8.052,359.291,0C351.236,8.052,9.23,350.05,1.175,358.104z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_copy"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EF4136",
    d: "M226.496,132.79v450.635c19.333,19.332,37.896,37.896,54.699,54.698V78.092 C264.392,94.895,245.829,113.458,226.496,132.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4136",
    d: "M359.291,0c-1.311,1.31-11.469,11.468-27.585,27.583v661.049c16.116,16.117,26.274,26.273,27.585,27.584 c1.298-1.297,11.273-11.271,27.114-27.112V27.112C370.564,11.272,360.588,1.297,359.291,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4136",
    d: "M435.519,76.224V639.99c16.531-16.53,34.822-34.821,53.922-53.919v-455.93 C470.341,111.043,452.05,92.754,435.519,76.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4136",
    d: "M540.402,181.101V535.11c19.03-19.031,38.028-38.027,56.14-56.14V237.238 C578.431,219.127,559.433,200.131,540.402,181.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4136",
    d: "M647.857,288.551v139.107c39.379-39.377,67.321-67.319,69.557-69.554 C715.179,355.87,687.236,327.928,647.857,288.551z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4136",
    d: "M1.175,358.104c2.288,2.288,31.526,31.525,72.395,72.395V285.712 C32.701,326.58,3.463,355.816,1.175,358.104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4136",
    d: "M124.969,234.314v247.583c16.967,16.968,34.665,34.664,52.402,52.402V181.913 C159.633,199.65,141.936,217.347,124.969,234.314z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Normal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.315,580.544V544.36h-14.661l-22.73,36.226v9.063h25.72v13.718h11.672v-13.718h7.311v-9.105H377.315z M365.644,580.544 h-16.339l16.339-25.021V580.544z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.857,327.511l-51.315-51.317l-56.14-56.138l-50.962-50.961l-53.922-53.922L386.405,66.06l-27.114-27.113 l-27.585,27.585l-50.51,50.511l-54.699,54.699l-49.125,49.126L124.97,273.27l-51.4,51.4l-29.999,29.998l29.999,29.999 l51.398,51.398l52.402,52.401l49.125,49.126l54.699,54.7l50.51,50.51l27.588,27.59l27.111-27.11l49.113-49.113l53.922-53.922 l50.962-50.963l56.14-56.139l51.315-51.314l27.159-27.16L647.857,327.511z M596.542,419.753l-56.14,56.139l-50.962,50.964 l-53.922,53.922l-49.113,49.112L359.293,657l-27.588-27.589l-50.51-50.51l-54.699-54.699l-49.125-49.127l-52.402-52.402 L73.57,371.274l-16.605-16.606l16.605-16.605l51.398-51.398l52.402-52.402l49.125-49.125l54.699-54.699l50.51-50.511l27.585-27.585 l27.114,27.113l49.113,49.113l53.922,53.92l50.962,50.962l56.14,56.139l51.315,51.314l13.769,13.769l-13.769,13.768 L596.542,419.753z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.405,32.226 402.875,48.698 408.989,42.584 376.669,10.262 373.111,13.819 370.555,16.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.716,97.423 460.272,93.867 427.951,61.545 421.835,67.659 435.519,81.339 454.16,99.981  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "489.44,135.261 505.441,151.262 511.555,145.149 479.233,112.828 475.675,116.385 473.119,118.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "559.282,199.988 562.838,196.432 530.516,164.109 524.402,170.223 540.402,186.223 556.724,202.545  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "596.542,242.362 608.006,253.827 614.119,247.713 581.797,215.393 578.242,218.948 575.684,221.506  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "661.846,302.551 665.401,298.996 633.081,266.674 626.967,272.787 647.857,293.679 659.287,305.109  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "684.361,317.957 680.807,321.512 678.248,324.07 710.57,356.391 713.128,353.833 716.684,350.276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.114,353.223 4.647,354.688 0,359.336 32.32,391.659 36.969,387.011 38.435,385.545  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.93,405.972 51.282,410.619 83.603,442.94 89.717,436.827 73.57,420.681 57.395,404.506  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.969,472.079 108.678,455.787 102.565,461.901 134.886,494.223 139.534,489.575 141,488.108  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.494,508.536 153.847,513.185 186.169,545.506 192.283,539.394 177.371,524.481 159.961,507.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.496,573.606 211.244,558.354 205.129,564.468 237.451,596.789 242.098,592.142 243.565,590.674  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.058,611.104 256.412,615.748 288.732,648.07 294.847,641.957 281.195,628.306 262.525,609.636  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.706,678.815 313.807,660.919 307.693,667.031 340.016,699.354 344.662,694.706 346.129,693.239  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.28,317.053 46.26,313.034 44.166,310.939 11.845,343.262 13.939,345.355 17.959,349.376  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.57,293.764 101.563,265.771 95.449,259.656 63.128,291.979 65.222,294.072 69.242,298.092  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.825,210.468 146.731,208.375 114.41,240.695 120.523,246.811 124.969,242.366 152.846,214.488  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.371,189.963 204.128,163.205 198.014,157.092 165.693,189.412 167.786,191.506 171.806,195.527  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.39,107.902 249.297,105.809 216.974,138.131 223.089,144.244 226.496,140.837 255.41,111.924  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.195,86.139 306.691,60.643 300.578,54.527 268.257,86.85 270.35,88.942 274.371,92.963  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.953,5.338 351.86,3.247 319.539,35.566 325.653,41.68 331.706,35.627 357.975,9.359  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.662,
    y: 692.409,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1140.5374 921.0349)",
    width: 45.708,
    height: 8.643
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.948,
    y: 641.126,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1191.8245 797.2361)",
    width: 45.709,
    height: 8.644
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.237,
    y: 589.819,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1243.1039 673.3827)",
    width: 45.711,
    height: 8.644
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.524,
    y: 538.479,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1294.3561 549.4685)",
    width: 45.711,
    height: 8.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561.808,
    y: 487.257,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1345.6812 425.7608)",
    width: 45.709,
    height: 8.646
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.089,
    y: 435.952,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1396.944 301.9309)",
    width: 45.706,
    height: 8.647
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.38,
    y: 384.706,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1448.2698 178.1754)",
    width: 45.709,
    height: 8.644
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.844,84.386c-14.621,27.926,3.193,43.69-16.446,84.827c-10.419-8.325-4.378-39.438-25.072-39.96 c3.184,9.554,0.801,13.266,0.27,16.716c-2.059,13.38-6.836,25.338,2.453,43.121c-14.269-6.933-14.505-19.654-26.57-27.631 c2.389,13.535-3.364,40.982,12.661,67.28c-14.279-1.405-19.015-6.896-34.47-21.706c16.129,83.56,28.129,85.906,87.278,90.647 c-4.457-0.521-34.259-5.282-45.053-39.627c-0.613-8.505-0.95,7.474,27.713,8.005c-18.149-28.743-13.205-23.303-11.081-40.022 c7.513,11.441,0.931,12.442,22.163,20.936c-6.731-21.387,10.389-36.021,6.674-60.438c4.691,10.723,21.379,9.034,20.584,60.52 c13.817-15.413,15.466-4.744,22.101-21.995c0.384,9.604,4.6,21.563-14.181,41.249c4.778,1.326,12.775,2.354,25.782-6.403 c-12.663,14.351-1.22,14.688-33.245,38.173c40.34,0.528,66.836-24.864,65.886-80.669c-1.062,4.776-2.251,14.314-24.014,17.235 c13.633-13.547,20.735-40.517,9.855-62.81c-3.832,3.563-9.786,20.129-24.118,24.907c7.269-11.926,5.636-27.36,5.636-27.36 s1.854-20.846-10.46-36.945c-3.448,25.212-3.16,37.892-19.085,41.873c2.563-14.88,3.033-21.81-4.929-38.795 C374.862,117.77,365.231,100.31,362.844,84.386z M296.23,311.867v7.409v7.428h71.001h71.001l-0.022-7.408l-0.021-7.386 l-70.958-0.02L296.23,311.867z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.496,
    y: 29.479,
    display: "inline",
    fill: "#99FFFF",
    width: 54.699,
    height: 667.207
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.706,
    y: -31.708,
    display: "inline",
    fill: "#99FFFF",
    width: 54.699,
    height: 857.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.519,
    y: 52.339,
    display: "inline",
    fill: "#99FFFF",
    width: 53.922,
    height: 656.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.402,
    y: 144.245,
    display: "inline",
    fill: "#99FFFF",
    width: 56.14,
    height: 481.939
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.857,
    y: 260.284,
    display: "inline",
    fill: "#99FFFF",
    width: 93.385,
    height: 206.014
  }), /*#__PURE__*/React.createElement("rect", {
    x: -24.758,
    y: 253.298,
    display: "inline",
    fill: "#99FFFF",
    width: 98.328,
    height: 217
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.969,
    y: 157.089,
    display: "inline",
    fill: "#99FFFF",
    width: 52.402,
    height: 410.944
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg41);
export default __webpack_public_path__ + "static/media/4.1.4b00a16f8fd9d711e7f7301c8ef3417c.svg";
export { ForwardRef as ReactComponent };